export default function reducer(state={
    tour:null,
    str_counts: null,
    categories:[],
    reviews:null,
    images: null,
    reviewsList:[],
    related_tours:[],
    max_day:0,
    price:null,
    new_cities:[],
    excursion:[],
    transports:[],
    city:[],
    types:[],
    transfer:false,
    transport:null,
    transportCost:0,
    news:null
},action){
switch(action.type){
    case "STORE_DAY_TOUR_DETAILS":{
        return{...state,
            tour: action.list.tour,
            str_counts: action.list.str_counts,
            categories: action.list.categories,
            reviews: action.list.review_details,
            images: action.list.images,
            reviewsList: action.list.reviewsList,
            related_tours: action.list.related_tours
        }
    }
    case "STORE_ROUND_TOUR_DETAILS":{
        return{...state,
            tour: action.list.tour,
            str_counts: action.list.str_counts,
            categories: action.list.categories,
            reviews: action.list.review_details,
            images: action.list.images,
            reviewsList: action.list.reviewsList,
            related_tours: action.list.related_tours,
            max_day:action.list.max_day
        }
    }
    case "STORE_MALDIVE_TOUR_DETAILS":{
        return{...state,
            tour: action.list.tour,
            reviews: action.list.review_details,
            images: action.list.images,
            reviewsList: action.list.reviewsList
        }
    }
    case "STORE_MALDIVE_TOUR_PRICE":{
        return{...state,
            price: action.price
        }
    }
    case "STORE_THINGS_TO_DO_DETAILS": {
        return{...state,
            tour: action.list.tour,
            related_tours: action.list.related_tours,
            new_cities: action.list.new_cities,
            categories: action.list.categories,
            excursion: action.list.excursion,
        }
    }
    case "STORE_TRANSFER_DETAILS": {
        return{...state,
            transfer:true,
            transports: action.list.transports,
            city: action.list.city,
            types: action.list.types
        }
    }
    case "STORE_RENT_CAR_DETAILS": {
        return{...state,
            transport: action.list.transport
        }
    }
    case "STORE_TRANSFER_AMOUNT": {
        return{...state,
            transportCost: action.result!=null?action.result.cost:0
        }
    }
    case "STORE_BLOG_DETAILS": {
        return{...state,
            news: action.list.news,
            related_tours: action.list.related_tours
        }
    }
    default:
        break;
}
return state
}